import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { AdvancedSearch } from './pages/advanced-search/advanced-search';
import { Libraries } from './pages/libraries/libraries';
import { IndexDetails } from './pages/index-details/index-details';
import { ContactUs } from './pages/contact-us/contact-us';
import { TimePeriodsQuran } from './pages/time-periods-quran/time-periods-quran';
import { QuranCalligraphiesQuran } from './pages/quran-calligraphies-quran/quran-calligraphies-quran';
import { TimePeriodsComponent } from './pages/time-periods/time-periods';
import { QuranCalligraphiesComponent } from './pages/quran-calligraphies/quran-calligraphies';
import { QuranDecorationsComponent } from './pages/quran-decorations/quran-decorations';
import { QuranDecorationsQuran } from './pages/quran-decorations-quran/quran-decorations-quran';
import { NewsComponent } from './pages/news/news.component';
import { NewsDetailsComponent } from './pages/news-details/news-details.component';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: Home },
    { path: 'advanced-search', component: AdvancedSearch },
    {
        path: 'browse-index',
        loadChildren: () =>
            import('./features/browse-index/browse-index.routes')
                .then(m => m.BROWSE_INDEX_ROUTES),
    },
    { path: 'libraries', component: Libraries },
    { path: 'index-details/:id', component: IndexDetails },
    { path: 'index-details', component: IndexDetails },  // fallback: query-param ?id=
    { path: 'contact-us', component: ContactUs },
    { path: 'time-periods', component: TimePeriodsComponent },
    { path: 'quran-calligraphies', component: QuranCalligraphiesComponent },
    { path: 'time-periods-quran/:id', component: TimePeriodsQuran },
    { path: 'quran-calligraphies-quran/:id', component: QuranCalligraphiesQuran },
    { path: 'quran-decorations', component: QuranDecorationsComponent },
    { path: 'quran-decorations-quran/:id', component: QuranDecorationsQuran },
    { path: 'news', component: NewsComponent },
    { path: 'news-details/:id', component: NewsDetailsComponent }
];
